import { Link } from "react-router-dom";
import type { Article } from "@/types/content";
import { formatDate, getMovieTitle } from "@/lib/content";

export default function ArticleCard({ article }: { article: Article }) {
  return (
    <article className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300">
      <Link to={`/news/${article.id}`} className="relative block aspect-[16/10] w-full overflow-hidden bg-secondary-100">
        <img
          src={article.cover}
          alt={`${article.title} 配图`}
          title={`${article.title} - 80s电影`}
          className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.04]"
        />
        <span className="absolute left-3 top-3 rounded-full bg-primary-800/90 px-2.5 py-1 font-label text-[11px] tracking-widest text-background-50">
          {article.type}
        </span>
      </Link>
      <div className="flex flex-1 flex-col p-4 md:p-5">
        <p className="flex flex-wrap items-center gap-2 text-[11px] text-secondary-600">
          <span>{formatDate(article.date)}</span>
          <span className="text-secondary-400">·</span>
          <span>{article.author}</span>
          <span className="text-secondary-400">·</span>
          <span>{article.readTime}</span>
        </p>
        <h3 className="mt-2 font-heading text-lg font-semibold leading-snug text-foreground-950">
          <Link to={`/news/${article.id}`} className="transition-colors hover:text-primary-700">
            {article.title}
          </Link>
        </h3>
        <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">{article.excerpt}</p>
        <div className="mt-auto flex flex-wrap items-center justify-between gap-2 pt-4">
          {article.movieId ? (
            <Link
              to={`/movie/${article.movieId}`}
              className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-2.5 py-1 text-[11px] text-secondary-900 transition-colors hover:bg-accent-100 hover:text-accent-900"
            >
              <i className="ri-film-line"></i>
              {getMovieTitle(article.movieId)}
            </Link>
          ) : (
            <span className="rounded-full bg-secondary-100 px-2.5 py-1 text-[11px] text-secondary-700">
              专题资料
            </span>
          )}
          <Link
            to={`/news/${article.id}`}
            className="inline-flex items-center gap-1 text-xs text-primary-700"
          >
            阅读全文
            <i className="ri-arrow-right-line text-[11px]"></i>
          </Link>
        </div>
      </div>
    </article>
  );
}